import {useApp} from "../app.context";
import {CSSProperties} from "react";
import {useIntegrator} from "../integrator.context";
import {ChangeLocalizationValuesCommand} from "../commands/changeLocalizationValues.command";
import TextArea from "./textArea.element";

interface LocalizationInputProps {
    id: string;
    style?: CSSProperties;
}

function LocalizationTextArea(props: LocalizationInputProps) {
    const {executeCommand} = useIntegrator();
    const {getLocalizationValue, navigateToLocalization} = useApp();

    return (
        <div className={'layout horizontal'} style={{gap: 4, flex: 1}}>
            <TextArea value={getLocalizationValue(props.id)} onChange={(value) =>
                executeCommand(new ChangeLocalizationValuesCommand(props.id, value))}
                style={{...props.style, borderColor: '#5a9a5a', borderRadius: 4, flex: 1}}
            />
            <span style={{
                      cursor: 'pointer', backgroundColor: '#5a9a5a', color: 'black',
                      width: 16, height: 16, borderRadius: '50%',
                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 10, fontWeight: 'bold', flexShrink: 0,
                      alignSelf: 'flex-start', marginTop: 6
                  }}
                  title={'Show in Localization editor'}
                  onClick={() => navigateToLocalization(props.id)}
            >A</span>
        </div>
    );
}

export default LocalizationTextArea;
